import styled, { css } from 'styled-components'
import { BlockStatus } from 'enum/block-status.enum'

interface IWrapperProps {
  status: BlockStatus
}

export const Wrapper = styled.div<IWrapperProps>`
  padding: 8px;
  margin-bottom: 24px;
  border-radius: 8px;
  font-size: 14px;
  color: #363636;
  svg {
    padding: 0 6px;
    margin-right: 8px;
  }
  span {
    font-weight: 700;
  }
  ${(props) =>
    props.status === BlockStatus.Pending &&
    css`
      border: 1px solid #d9d9d9;
      background: #f5f5f5;
    `}
  ${(props) =>
    props.status === BlockStatus.InProgress &&
    css`
      border: 1px solid #ffeaa3;
      background: #fff9e3;
      svg {
        color: #d48806;
      }
    `}
  ${(props) =>
    props.status === BlockStatus.Finish &&
    css`
      border: 1px solid #88e3bc;
      background: #d7f5e9;
      svg {
        color: #0c9159;
      }
    `}
`
